import { useState, useContext } from "react";
import { ModalController } from "../../homeUI/_index";
import Pagination from "@mui/material/Pagination";

import moment from "moment";
import { _onClickFuncs, _onClickOther } from "../../../funcs/onClickShowBtn";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import BlockIcon from "@mui/icons-material/Block";

const MobileDeliverPropose = (props: any) => {
  // const data = props.data;
  // const _loadData = props._loadData;

  // const [page, setPage] = useState<number>(0);
  // // for pagination
  // const limitPerPage = 10;

  const data = props.data;
  const page = props.page;
  const setPage = props.setPage;

  const totalPage = props.totalPage;
  const limitPerPage = props.limitPerPage;
  const setLimitPerPage = props.setLimitPerPage;
  const _loadData = props._loadData;

  const context = useContext(ModalController);

  // onClick detail
  const _onClickDetail = (id: string) => {
    context.handleOpen();
    context.setFuncs("proposeDetail");
    context.setTaskId(id);
  };

  const _onChangePaginate = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value - 1);
  };

  return (
    <div className="mobile-table-propose">
      {/* page selection */}
      <div className="flex w-max h-max pb-2">
        <p>Xem</p>
        <select
          className="border-2 border-slate-200 rounded-md"
          value={limitPerPage}
          onChange={(e) => {
            setLimitPerPage(parseInt(e.target.value));
          }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
        <p>dòng</p>
      </div>

      <table className="w-full">
        <thead className="text-white font-semibold text-center w-full h-[2rem]">
          <tr>
            <th className="w-1/12">Danh sách đề xuất</th>
          </tr>
        </thead>
        <tbody>
          {data?.length !== 0 ? (
            <>
              {data?.map((item: any, index: any) => (
                <tr key={index}>
                  <td className="trang-thai-moi border border-slate-300">
                    <p className="font-bold">
                      {index + 1 + page * limitPerPage}.&nbsp;{item.Name}
                    </p>

                    <div>
                      <span className="text-xs">Người nhận: </span>
                      <span className="font-semibold">
                        {item.UserCheckName}
                      </span>
                    </div>
                    <div>
                      <span className="text-xs">Ngày gửi:&nbsp;</span>
                      <span className="italic">
                        {moment(item.DateAdd).format("DD/MM/YYYY HH:mm")}
                      </span>
                    </div>
                    <div>
                      {item.IsUseTime === true ? (
                        <>
                          <span className="text-xs">Thời gian thực hiện:</span>
                          <br />
                          <span className="italic">
                            {moment(item.StartTime).format("DD/MM/YYYY hh:mm")}
                            &nbsp;-&nbsp;
                            {moment(item.EndTime).format("DD/MM/YYYY hh:mm")}
                          </span>
                        </>
                      ) : (
                        <>Đề xuất không thời hạn</>
                      )}
                    </div>
                    <div className="flex justify-between items-center pt-1.5">
                      <p className="text-xs">
                        {item?.Status === 0 ? (
                          <span className="p-1 text-yellow-500 rounded-md border border-yellow-500">
                            Chưa duyệt
                          </span>
                        ) : item?.Status === 1 ? (
                          <span className="p-1 text-green-500 rounded-md border border-green-500">
                            Đã duyệt
                          </span>
                        ) : (
                          <span className="p-1 text-red-500 rounded-md border border-red-500">
                            Không duyệt
                          </span>
                        )}
                      </p>
                      <div className="h-full lg:hidden flex pl-3">
                        <div className="dropdown2">
                          <button
                            className="dropbtn2"
                            onClick={() => _onClickFuncs(index.toString())}
                          >
                            ...
                          </button>

                          <div
                            id={index.toString()}
                            className="dropdown-content2 text-xs font-semibold"
                          >
                            <button
                              className="flex w-full h-full hover:text-sky-500"
                              onClick={() => _onClickDetail(item.ID)}
                            >
                              <div className="flex w-full h-full space-x-1">
                                <div>Chi tiết</div>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </>
          ) : (
            <></>
          )}
        </tbody>
      </table>
      {/* pagination */}
      <div className="flex lg:flex-row flex-col items-center lg:justify-end w-full h-[2rem]">
        <Pagination
          count={props.totalPage}
          variant="outlined"
          color="primary"
          size="small"
          page={props.page + 1}
          onChange={_onChangePaginate}
        />
      </div>
    </div>
  );
};

export default MobileDeliverPropose;
